if (!customElements.get('wl-pd-gallery')) {
  class WlPdGallery extends HTMLElement {
    constructor() {
      super();

      this.thumbTrack = this.querySelector('[data-thumbs-track]');
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.thumbsPrev = this.querySelector('[data-thumbs-prev]');
      this.thumbsNext = this.querySelector('[data-thumbs-next]');

      this.lightbox = this.querySelector('[data-lightbox]');
      this.lightboxTrack = this.querySelector('[data-lightbox-track]');
      this.lightboxSlides = Array.from(this.querySelectorAll('[data-lightbox-slide]'));
      this.lightboxPrev = this.querySelector('[data-lightbox-prev]');
      this.lightboxNext = this.querySelector('[data-lightbox-next]');
      this.lightboxCurrent = this.querySelector('[data-lightbox-current]');
      this.closeEls = Array.from(this.querySelectorAll('[data-lightbox-close]'));

      this.activeIndex = 0;
      this.lastFocused = null;
      this.scrollTimeout = null;

      // The hero section clips overflow, which would clip a position:fixed
      // lightbox too — escape to <body> so it can cover the full viewport.
      if (this.lightbox) document.body.appendChild(this.lightbox);

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.openLightbox(parseInt(thumb.dataset.index, 10), thumb);
        });
      });

      if (this.thumbsPrev) this.thumbsPrev.addEventListener('click', () => this.scrollThumbs(-1));
      if (this.thumbsNext) this.thumbsNext.addEventListener('click', () => this.scrollThumbs(1));
      if (this.lightboxPrev) this.lightboxPrev.addEventListener('click', () => this.stepLightbox(-1));
      if (this.lightboxNext) this.lightboxNext.addEventListener('click', () => this.stepLightbox(1));

      this.closeEls.forEach((el) => el.addEventListener('click', () => this.closeLightbox()));

      document.addEventListener('keydown', (event) => {
        if (!this.lightbox || this.lightbox.hidden) return;
        if (event.key === 'Escape') this.closeLightbox();
        if (event.key === 'ArrowLeft') this.stepLightbox(-1);
        if (event.key === 'ArrowRight') this.stepLightbox(1);
      });

      if (this.lightboxTrack) {
        this.lightboxTrack.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimeout);
          this.scrollTimeout = setTimeout(() => this.syncFromScroll(), 100);
        });
      }
    }

    scrollThumbs(direction) {
      if (!this.thumbTrack) return;
      this.thumbTrack.scrollBy({ left: this.thumbTrack.clientWidth * 0.8 * direction, behavior: 'smooth' });
    }

    openLightbox(index, opener) {
      if (!this.lightbox) return;
      this.activeIndex = index;
      this.lastFocused = opener || document.activeElement;
      this.lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      this.scrollLightboxTo(index, false);
      this.updateActiveStates();
      requestAnimationFrame(() => {
        const closeBtn = this.querySelector('.wl-pd-hero__lightbox-close');
        if (closeBtn) closeBtn.focus();
      });
    }

    closeLightbox() {
      if (!this.lightbox) return;
      this.lightbox.hidden = true;
      document.body.style.overflow = '';
      if (this.lastFocused) this.lastFocused.focus();
    }

    stepLightbox(direction) {
      const next = Math.min(Math.max(this.activeIndex + direction, 0), this.lightboxSlides.length - 1);
      if (next === this.activeIndex) return;
      this.activeIndex = next;
      this.scrollLightboxTo(next, true);
      this.updateActiveStates();
    }

    scrollLightboxTo(index, smooth) {
      const slide = this.lightboxSlides[index];
      if (!slide || !this.lightboxTrack) return;
      this.lightboxTrack.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    }

    syncFromScroll() {
      if (!this.lightboxTrack) return;
      const scrollLeft = this.lightboxTrack.scrollLeft;
      let closest = 0;
      let closestDist = Infinity;
      this.lightboxSlides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft - scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      if (closest !== this.activeIndex) {
        this.activeIndex = closest;
        this.updateActiveStates();
      }
    }

    updateActiveStates() {
      this.thumbs.forEach((thumb, i) => {
        const isActive = i === this.activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      if (this.lightboxCurrent) this.lightboxCurrent.textContent = this.activeIndex + 1;
      if (this.lightboxPrev) this.lightboxPrev.disabled = this.activeIndex === 0;
      if (this.lightboxNext) this.lightboxNext.disabled = this.activeIndex === this.lightboxSlides.length - 1;
    }
  }

  customElements.define('wl-pd-gallery', WlPdGallery);
}
